module.exports = __webpack_public_path__ + "img/chanpin_5@2x.78eae82b.png";